import DealerPackageListPanel from "./dealerPackageListPanel.container"

export default DealerPackageListPanel
